export default class ZipFileModel {
  public filename: string
  public lastModified: Date
  public size: number
  public contents: ZipFileModel[]
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  constructor (json: Record<string, any>) {
    this.validateJson(json)
    this.filename = json.filename
    this.lastModified = new Date(json.lastModified)
    this.size = json.size
    this.contents = []

    if (json.contents && typeof json.contents === 'object') {
      for (let i = 0; i < json.contents.length; i++) {
        this.contents.push(new ZipFileModel(json.contents[i]))
      }
    }
  }

  /**
   * calc megabytes from bytes with two rounded decimals
   */
  public getSizeInMb (): number {
    return Math.round(this.size / 1024 / 1024 * 100) / 100
  }

  public getLastModifiedFormatted (): string {
    const options = {
    }

    return this.lastModified.toLocaleDateString('de-DE', options)
  }

  /* eslint-disable  @typescript-eslint/no-explicit-any */
  private validateJson (json: Record<string, any>): void | never {
    if (
      !json ||
      !json.filename ||
      !json.lastModified ||
      !json.size
    ) {
      throw new Error('ZipFileModel::new invalid data given')
    }
  }
}
